/**
 * Laadt reCAPTCHA pas als iemand het contactformulier nodig heeft.
 *
 * De footer zet de uitvoer van de {{ recaptcha }}-tag in een <template>, waar
 * scripts niet uitgevoerd worden. Komt een formulier in de buurt van het beeld,
 * of klikt of typt iemand erin, dan zetten we die scripts alsnog in de pagina.
 * De addon koppelt daarna zelf zijn submit-handler aan de formulieren.
 *
 * Wie versneld verstuurt voordat Google geladen is (automatisch invullen en
 * meteen op Enter), wordt even vastgehouden: het versturen gaat door zodra
 * reCAPTCHA klaar is, zodat er een token bij de inzending zit.
 */

const sjabloon = document.getElementById('recaptcha-loader');
const formulieren = document.querySelectorAll('form:not(.nocaptcha)');

let geladen = false;

if (sjabloon && formulieren.length > 0) {
    formulieren.forEach(bewaak);
}

function bewaak(formulier) {
    ['focusin', 'pointerdown'].forEach((gebeurtenis) => {
        formulier.addEventListener(gebeurtenis, laad, { once: true, passive: true });
    });

    formulier.addEventListener('submit', (event) => {
        if (window.grecaptcha?.execute) {
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        laad();
        verstuurZodraKlaar(formulier);
    }, { capture: true });

    if ('IntersectionObserver' in window) {
        const waarnemer = new IntersectionObserver((items) => {
            if (items.some((item) => item.isIntersecting)) {
                waarnemer.disconnect();
                laad();
            }
        }, { rootMargin: '400px 0px' });

        waarnemer.observe(formulier);
    }
}

function laad() {
    if (geladen) {
        return;
    }

    geladen = true;

    // Een gekloond script uit een template draait niet, dus bouwen we elk script opnieuw op.
    sjabloon.content.querySelectorAll('script').forEach((origineel) => {
        const script = document.createElement('script');

        [...origineel.attributes].forEach(({ name, value }) => script.setAttribute(name, value));
        script.async = false;
        script.textContent = origineel.textContent;

        document.body.appendChild(script);
    });
}

function verstuurZodraKlaar(formulier) {
    const poging = setInterval(() => {
        if (!window.grecaptcha?.ready) {
            return;
        }

        clearInterval(poging);

        // De addon hangt zijn eigen submit-handler ook in grecaptcha.ready; even wachten
        // zorgt dat die er staat voordat we het formulier opnieuw versturen.
        window.grecaptcha.ready(() => setTimeout(() => formulier.requestSubmit(), 250));
    }, 100);
}
